import React from 'react';
import ImgHTML from '../../ImgHTML';

const CultureItem = ({ mainText, secText, terText, img, version }) => {
  return (
    <div className={`${version === 'twoPerRow' ? 'col-md-5' : 'col-md-4'}`}>
      <div className="item">
        <div className="icon">
          <ImgHTML src={img} alt="our company" />
        </div>
        <div className="content">
          <h3 className="h6 font-weight-bold">{mainText}</h3>
          <p>{secText}</p>
          <p>{terText}</p>
        </div>
      </div>
    </div>
  );
};

export default CultureItem;
